angular.module('cpm').constant('SHARING_TYPES', {
    STANDARD: 'STD',
    PUBLIC: 'PUB',
    CLIENT: 'CLI',
    ADVERTISER: 'ADV',
    ACCOUNT: 'ACC',
    PRIVATE: 'PRV',
});
